import * as React from 'react';
import classNames from 'classnames';

export interface AccordionPanelProps {
  children: React.ReactNode;
  className?: string;
  open: boolean;
  id: string;
}

function AccordionPanel(props: AccordionPanelProps) {
  const { id, children, className, open } = props;

  return (
    <div
      className={classNames(className, 'ui-accordion-panel', {
        'ui-accordion-panel--open': open,
      })}
      id={`panel${id}-content`}
      aria-labelledby={`panel${id}-header`}
      role="region"
    >
      <div aria-hidden={!open} className="ui-accordion-panel-inner">
        {children}
      </div>
    </div>
  );
}

export default AccordionPanel;
